// extracted by mini-css-extract-plugin
export default {"Main":"Component_Main__Aa-gf","NotStarted":"Component_NotStarted__nfSCM","Error":"Component_Error__mva8g","InProgress":"Component_InProgress__2TEFN","Done":"Component_Done__DKIek"};